import Secao from './Secao'
import TiposDeSecoesEnum from './TiposDeSecoesEnum'

export default class SecaoPersonalizada extends Secao {
  constructor({ id = 0, idFormulario = 0, titulo = '', linhas = 0, colunas = 0, elementos = [] } = {}) {
    super(id, idFormulario, TiposDeSecoesEnum.Personalizada, titulo, linhas, colunas, elementos)
  }
}
